'use client';
import clsx from 'clsx';
import { When } from 'react-if';

import cn from '@/lib/clsxm';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import PriceView from '@/components/shared/components/price-view';
import useAddToCartHandler from '@/components/shared/helpers/hooks/use-add-to-cart-handler';

import SmartOfferModel from '@/models/smart-offer.model';

export default function SmartInLineCart({ data }: { data: SmartOfferModel }) {
  const { handleAddToCart, isAddingToCart } = useAddToCartHandler();

  const handleAddToCartClick = () => {
    handleAddToCart({ data });
  };
  return (
    <Container
      className={cn(
        'mt-3 flex w-full flex-col justify-between rounded-xl bg-[#FFF5E6] pt-2.5 pr-2 pb-3 pl-2 md:h-[138px] md:pr-3 md:pl-3',
      )}
    >
      <Container className='flex items-center justify-start gap-2 border-b border-dashed border-[#7E899B33] pr-1 pb-2 md:justify-start md:pr-3'>
        <XImage
          width={48}
          height={48}
          src={data?.product?.icon?.publicLink}
          alt={data?.title}
          className='h-[48px] rounded-[10px] object-cover object-center'
        />

        <Container className='mt-1'>
          <Text className='line-clamp-1 text-[16px] leading-8 font-bold text-[#424244]'>
            {data?.title}
          </Text>
          <Text className='line-clamp-2 text-[14px] font-medium text-[#76767C]'>
            {data?.description}
          </Text>
        </Container>
      </Container>
      <Container
        className={clsx(
          data?.product?.price ? 'justify-between!' : 'justify-end',
          'relative mt-2 ml-3 flex flex-row items-center gap-2 pr-1 md:mx-0 md:gap-1 md:pr-3',
          data?.product?.discount && data?.product?.discount > 0
            ? 'mr-8! w-[90%] md:w-[93%]'
            : 'mr-0 w-full!',
        )}
      >
        <When condition={data?.product?.price}>
          <Container
            className={cn(
              'relative',
              data?.product?.discount && data?.product?.discount > 0
                ? 'mr-2.5 md:mr-2'
                : 'mr-0',
            )}
          >
            <PriceView
              discountLabelClassName='absolute -right-10  top-[15%] mx-auto border-[#FFFFFF] border-[2px] w-[34px] h-[34px] shadow-[0px_4px_12px_-5px_#FF7B016E]'
              showDiscountLabel={true}
              key={data?.id}
              price={data?.product?.price}
              lastPrice={data?.product?.lastPrice}
              discount={data?.product?.discount}
              lastPriceClassName='text-sm! -mb-2.5!'
              priceClassName='text-lg! font-600!'
              discountClassName='text-xs! font-medium! pt-0.5'
            />
          </Container>
        </When>
        <Button
          className='mt-1.5 ml-2 h-10 w-fit min-w-[110px] rounded-lg! border-1 border-[#FFB616] bg-[#FFB616]! px-5! text-xs whitespace-nowrap transition-colors! duration-500 hover:border-1 hover:border-[#F89406] hover:bg-[#FFF]! hover:px-5! hover:text-[#F89406] md:mt-0 md:ml-1'
          onClick={handleAddToCartClick}
          isLoading={isAddingToCart}
        >
          {data?.buttonText}
        </Button>
      </Container>
    </Container>
  );
}
